import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { isValidObject, isValidString } from '../../../../catalog/Validity';
import { context } from '../../../../globalState/GlobalState';
import './css/GameFeatureImage1.css';
import { getFullDateStringFromDate, getLocalTimeFromDatabaseTime, getDateTimeStringFromDate } from '../../../../catalog/DateTime';
import { randomNumber } from '../../../../catalog/Others';
import { getOptimXBackgroundStyle, getWebsiteImage } from '../../../../catalog/Website';
import BreadCrumbs1 from '../../../uiElements/breadCrumbs/breadCrumbs1/BreadCrumbs1';
import { opponentGoalsDescription as opponentIceHockeyGoalsDescription, ourGoalsDescription as ourIceHockeyGoalsDescription } from '../../../../catalog/stats/iceHockey/IceHockeyStatsDescription';
import { opponentGoalsFromGame as opponentIceHockeyGoalsFromGame, ourGoalsFromGame as ourIceHockeyGoalsFromGame } from '../../../../catalog/stats/iceHockey/IceHockeyGameStats';
import { opponentPointsFromGame, ourPointsFromGame } from '../../../../catalog/stats/rugby/RugbyGameStats';
import { opponentPointsDescriptionFromGame, ourPointsDescriptionFromGame } from '../../../../catalog/stats/rugby/RugbyStatsDescription';
import { opponentGoalsDescription as opponentLacrosseGoalsDescription, ourGoalsDescription as ourLacrosseGoalsDescription } from '../../../../catalog/stats/lacrosse/LacrosseStatsDescription';
import { opponentGoalsFromGame as opponentLacrosseGoalsFromGame, ourGoalsFromGame as ourLacrosseGoalsFromGame } from '../../../../catalog/stats/lacrosse/LacrosseGameStats';
import { SportsType } from '../../../../catalog/enums/SportsType';

const GameFeatureImage1 = (props) => {
    const { title, game, featureImage, opponentName, opponentLogo, status, homeGame, venue, timeOfGame } = props;
    const { globalState } = useContext(context);

    const getBreadCrumbsLinks = () => {
        return [
            {
                title: 'Home',
                link: '/',
            },
            {
                title: 'Schedule',
                link: '/schedule',
            },
        ];
    };

    const getImage = () => {
        if (isValidObject(featureImage)) {
            return featureImage;
        } if (isValidObject(getWebsiteImage(globalState, 'gameFeatureImage'))) {
            return getWebsiteImage(globalState, 'gameFeatureImage');
        } if (isValidObject(getWebsiteImage(globalState, 'featureImage1'))) {
            return getWebsiteImage(globalState, 'featureImage1');
        }
        return '';

        // if (isValidString(getWebsiteImage(globalState, 'gameFeatureImage'))) {
        //     return getWebsiteImage(globalState, 'gameFeatureImage');
        // }
        // return '';
    };

    const isUpcomingGame = () => {
        return getLocalTimeFromDatabaseTime(timeOfGame) > new Date();
    };

    const getStatus = () => {
        if (status === 'tbat') {
            return isUpcomingGame() ? 'Scheduled' : 'Finished';
        }
        return status;
    };

    const getTimeOfGame = () => {
        if (status === 'tba') {
            return '';
        } if (status === 'tbat') {
            return getFullDateStringFromDate(getLocalTimeFromDatabaseTime(timeOfGame));
        }
        return getDateTimeStringFromDate(getLocalTimeFromDatabaseTime(timeOfGame));
    };

    const getScore = () => {
        if (status === 'tba' || status === 'tbat' || status === 'cancelled' || status === 'scheduled' || status === 'postponed') {
            return 'vs';
        }
        if (!homeGame) {
            if (globalState.sportsType === SportsType.WOMENSICEHOCKEY || globalState.sportsType === SportsType.MENSICEHOCKEY) {
                return `${ourIceHockeyGoalsFromGame(game)} - ${opponentIceHockeyGoalsFromGame(game)}`;
            }
            if (globalState.sportsType === SportsType.WOMENSRUGBY || globalState.sportsType === SportsType.MENSRUGBY) {
                return `${ourPointsFromGame(game)} - ${opponentPointsFromGame(game)}`;
            }
            if (globalState.sportsType === SportsType.WOMENSLACROSSE || globalState.sportsType === SportsType.MENSLACROSSE) {
                return `${ourLacrosseGoalsFromGame(game)} - ${opponentLacrosseGoalsFromGame(game)}`;
            }
        }
        if (globalState.sportsType === SportsType.WOMENSICEHOCKEY || globalState.sportsType === SportsType.MENSICEHOCKEY) {
            return `${opponentIceHockeyGoalsFromGame(game)} - ${ourIceHockeyGoalsFromGame(game)}`;
        }
        if (globalState.sportsType === SportsType.WOMENSRUGBY || globalState.sportsType === SportsType.MENSRUGBY) {
            return `${opponentPointsFromGame(game)} - ${ourPointsFromGame(game)}`;
        }
        if (globalState.sportsType === SportsType.WOMENSLACROSSE || globalState.sportsType === SportsType.MENSLACROSSE) {
            return `${opponentLacrosseGoalsFromGame(game)} - ${ourLacrosseGoalsFromGame(game)}`;
        }
        return 'vs';
    };

    const getScoreDescription = (our) => {
        if (our) {
            if (globalState.sportsType === SportsType.WOMENSICEHOCKEY || globalState.sportsType === SportsType.MENSICEHOCKEY) {
                return ourIceHockeyGoalsDescription(game.goals);
            }
            if (globalState.sportsType === SportsType.WOMENSRUGBY || globalState.sportsType === SportsType.MENSRUGBY) {
                return ourPointsDescriptionFromGame(game);
            }
            if (globalState.sportsType === SportsType.WOMENSLACROSSE || globalState.sportsType === SportsType.MENSLACROSSE) {
                return ourLacrosseGoalsDescription(game.goals);
            }
        }
        if (globalState.sportsType === SportsType.WOMENSICEHOCKEY || globalState.sportsType === SportsType.MENSICEHOCKEY) {
            return opponentIceHockeyGoalsDescription(game.goals);
        }
        if (globalState.sportsType === SportsType.WOMENSRUGBY || globalState.sportsType === SportsType.MENSRUGBY) {
            return opponentPointsDescriptionFromGame(game);
        }
        if (globalState.sportsType === SportsType.WOMENSLACROSSE || globalState.sportsType === SportsType.MENSLACROSSE) {
            return opponentLacrosseGoalsDescription(game.goals);
        }
        return [];
    };

    const getVenue = () => {
        if (isValidString(venue)) {
            if (venue.length > 30) {
                return `${venue.substr(0, 30)}...`;
            }
            return venue;
        }
        if (homeGame) {
            return 'HOME';
        }

        return 'AWAY';
    };

    return (
        <>
            <div className="game-feature-image1-navbar full-width" style={getOptimXBackgroundStyle(globalState)}>
                <BreadCrumbs1 links={getBreadCrumbsLinks()} lastCrumb={title} marginLeft="100px" marginTop="0px" fontColor={globalState.websiteStyles.colors.fontColor} />
            </div>
            <div className="game-feature-image1-container">
                <img className="game-feature-image1" src={getImage()} alt="Game Feature" />
                <div className="game-feature-image1-scorecard full-width">
                    {!homeGame ? (
                        <>
                            <div className="game-feature-image1-team right-align">
                                {isValidObject(globalState.logo) && isValidString(globalState.logo.logo2) ? (
                                    <img className="game-feature-image1-logo m-r-20px" src={globalState.logo.logo2} alt={globalState.teamAlias} />
                                ) : null}
                                <div className="game-feature-image1-logo-text-container full-width">
                                    <p className="game-feature-image1-title font-size-xl text-white text-right-align m-t-0 m-b-3px full-width text-uppercase">{globalState.teamAlias}</p>
                                    <div className="game-feature-image1-scorers full-width">
                                        {isUpcomingGame() ? null : (
                                            <>
                                                {getScoreDescription(true).map((score) => {
                                                    return (
                                                        score ? <div key={randomNumber()} className="normal-font-family text-uppercase text-right-align font-size-xs text-white full-width m-t-3px m-b-3px">{score}</div> : null
                                                    );
                                                })}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="game-feature-image1-middle text-white">
                                <p className="font-size-s m-t-0 m-b-5px normal-font-family text-uppercase font-weight-200 font-spacing-wider">{getStatus()}</p>
                                <p className="game-feature-image1-score font-size-6xl full-width m-t-0 m-b-0">
                                    {getScore()}
                                </p>
                                <p className="font-size-xs m-t-0 m-b-0 normal-font-family text-uppercase font-weight-200 font-spacing-wider text-center-align">{getVenue()}</p>
                                <p className="font-size-s m-t-0 m-b-5px normal-font-family text-uppercase font-weight-200 font-spacing-wider text-center-align">{getTimeOfGame()}</p>
                            </div>
                            <div className="game-feature-image1-team left-align">
                                <div className="game-feature-image1-logo-text-container full-width">
                                    <p className="game-feature-image1-title font-size-xl text-white text-left-align m-t-0 m-b-3px full-width text-uppercase">{opponentName}</p>
                                    <div className="game-feature-image1-scorers full-width">
                                        {isUpcomingGame() ? null : (
                                            <>
                                                {getScoreDescription(false).map((score) => {
                                                    return (
                                                        score ? <div key={randomNumber()} className="normal-font-family text-uppercase text-left-align font-size-xs text-white full-width m-t-3px m-b-3px">{score}</div> : null
                                                    );
                                                })}
                                            </>
                                        )}
                                    </div>
                                </div>
                                {isValidString(opponentLogo) ? (
                                    <img className="game-feature-image1-logo m-l-20px" src={opponentLogo} alt={opponentName} />
                                ) : null}
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="game-feature-image1-team right-align">
                                {isValidString(opponentLogo) ? (
                                    <img className="game-feature-image1-logo m-r-20px" src={opponentLogo} alt={opponentName} />
                                ) : null}
                                <div className="game-feature-image1-logo-text-container full-width">
                                    <p className="game-feature-image1-title font-size-xl text-white text-right-align m-t-0 m-b-3px full-width text-uppercase">{opponentName}</p>
                                    <div className="game-feature-image1-scorers full-width">
                                        {isUpcomingGame() ? null : (
                                            <>
                                                {getScoreDescription(false).map((score) => {
                                                    return (
                                                        score ? <div key={randomNumber()} className="normal-font-family text-uppercase text-right-align font-size-xs text-white full-width m-t-3px m-b-3px">{score}</div> : null
                                                    );
                                                })}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="game-feature-image1-middle text-white">
                                <p className="font-size-s m-t-0 m-b-5px normal-font-family text-uppercase font-weight-200 font-spacing-wider">{getStatus()}</p>
                                <p className="game-feature-image1-score font-size-6xl full-width m-t-0 m-b-0">
                                    {getScore()}
                                </p>
                                <p className="font-size-xs m-t-0 m-b-0 normal-font-family text-uppercase font-weight-200 font-spacing-wider text-center-align">{getVenue()}</p>
                                <p className="font-size-s m-t-0 m-b-5px normal-font-family text-uppercase font-weight-200 font-spacing-wider text-center-align">{getTimeOfGame()}</p>
                            </div>
                            <div className="game-feature-image1-team left-align">
                                <div className="game-feature-image1-logo-text-container full-width">
                                    <p className="game-feature-image1-title font-size-xl text-white text-left-align m-t-0 m-b-3px full-width text-uppercase">{globalState.teamAlias}</p>
                                    <div className="game-feature-image1-scorers full-width">
                                        {isUpcomingGame() ? null : (
                                            <>
                                                {getScoreDescription(true).map((score) => {
                                                    return (
                                                        score ? <div key={randomNumber()} className="normal-font-family text-uppercase text-left-align font-size-xs text-white full-width m-t-3px m-b-3px">{score}</div> : null
                                                    );
                                                })}
                                            </>
                                        )}
                                    </div>
                                </div>
                                {isValidObject(globalState.logo) && isValidString(globalState.logo.logo2) ? (
                                    <img className="game-feature-image1-logo m-l-20px" src={globalState.logo.logo2} alt={globalState.teamAlias} />
                                ) : null}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

GameFeatureImage1.propTypes = {
    title: PropTypes.string.isRequired,
    game: PropTypes.object.isRequired,
    featureImage: PropTypes.string.isRequired,
    opponentName: PropTypes.string.isRequired,
    opponentLogo: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    homeGame: PropTypes.bool.isRequired,
    venue: PropTypes.string.isRequired,
    timeOfGame: PropTypes.object.isRequired,
};

export default memo(GameFeatureImage1);
